import { Lookup } from './lookup.model';
import { OptionSet } from './optionSet.model';
export class Puntaje {
    TipoRegistro: OptionSet;
    PuntajePromedioPsu: number;
    AnhoPsu: number;
    Ranking: number;
    UbicacionNem: number;
    PercentilPSU: number;

    Contacto: Lookup;
    NotaPrimeroMedio: number;
    NotaSegundoMedio: number;
    NotaTerceroMedio: number;
    NotaCuartoMedio: number;
    HabilitadoPedagogia: boolean;
    
    constructor(data: any) {
        this.Contacto= new Lookup(data.IdContacto, 'contact');
        this.PuntajePromedioPsu=data.PuntajePromedioPsu;
        this.Ranking=data.Ranking;
        this.AnhoPsu=data.AnhoPsu;
        this.TipoRegistro=new OptionSet('1');
     }
}